import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import {
  Scheduler, DayView, WeekView, MonthView, AgendaView,
  TimelineView
} from '@progress/kendo-react-scheduler';
import { Switch } from '@progress/kendo-react-inputs';
import { DateInput } from '@progress/kendo-react-dateinputs';
import { Calendar } from '@progress/kendo-react-dateinputs';
// import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
// import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
// import currencyData from 'cldr-core/supplemental/currencyData.json';
// import weekData from 'cldr-core/supplemental/weekData.json';
// import numbers from 'cldr-numbers-full/main/pt/numbers.json';
// import caGregorian from 'cldr-dates-full/main/pt-PT/ca-gregorian.json';
// import dateFields from 'cldr-dates-full/main/pt-PT/dateFields.json';
// import timeZoneNames from 'cldr-dates-full/main/pt-PT/timeZoneNames.json';
// import currencies from 'cldr-numbers-full/main/pt-PT/currencies.json';
// import esMessages from '../../lang/tlklang.json';
import $ from 'jquery'
var moment = require('moment')


// load(
//   likelySubtags,
//   currencyData,
//   weekData,
//   numbers,
//   currencies,
//   caGregorian,
//   dateFields,
//   timeZoneNames
// );

// loadMessages(esMessages, 'pt-PT');
const dateFormat = 'YYYY-MM-DD';
const Timeformat = 'HH:mm';
let today = new Date();
let current_date = moment(today).format(dateFormat);

class CalenderModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: null
    }
  }

  componentDidMount() {
    this.createState();
  }
  componentDidUpdate(preProp) {
    if (preProp.date !== this.props.date) {
      this.createState();
    }
  }

  createState = () => {
    this.setState({
      value: new Date(this.props.data.deadline_date),
    });
  }


  onSelect = (value) => {
    this.updateDate(value)
  };

  onPanelChange = (value) => {
    this.updateDate(value)
  };

  updateDate = (e) => {
    console.log(e);
    this.setState({
      value:e.value
    });
    
    this.props.onCalenderChange(moment(e.value).format(dateFormat));
  }


  render() {
    return (
      // <LocalizationProvider language="pt-PT">
        // <IntlProvider locale="pt-PT" >
        <>
          {
            this.state.value &&
            <Calendar
            style={{width:"100%"}}
              className="deadlineclender"
              defaultValue={new Date(this.state.value)}
              onChange={this.updateDate}
            />
          }
        </>
        // </IntlProvider>
      // </LocalizationProvider>

    )
  }

}


export default CalenderModal;